import React from "react";
import About from "../../components/About";
import { Backdrop, CircularProgress, Container } from "@mui/material";

const AboutPage = ({
	genericDataLoaded
}) => {
	const pageIsLoading = genericDataLoaded === false;

	return (
		<Container maxWidth="lg">
			<About/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};
export default AboutPage;